(() => {
  /*
   * KOURITEN PRODUCT CARD COUNTDOWN
   *
   * This file is intentionally limited to Product Card countdowns.
   *
   * Product Page countdowns are owned exclusively by the
   * Kouriten Countdown Theme App Extension.
   *
   * ACTIVE:
   *   countdown runs normally
   *
   * EXPIRED:
   *   disable relevant card purchase controls
   *   show "預購結束"
   *
   * NO COUNTDOWN:
   *   do nothing
   */

  const CARD_SELECTOR =
    ".kouriten-product-card-countdown";

  const EXPIRED_TEXT =
    "預購結束";

  const DISABLED_CLASS =
    "kouriten-countdown-disabled";


  function pad(value) {
    return String(value).padStart(2, "0");
  }


  function formatRemaining(endAt) {
    const end =
      new Date(endAt).getTime();

    if (Number.isNaN(end)) {
      return null;
    }

    const remaining =
      end - Date.now();

    if (remaining <= 0) {
      return {
        expired: true,
        text: EXPIRED_TEXT,
      };
    }

    const totalSeconds =
      Math.floor(remaining / 1000);

    const days =
      Math.floor(totalSeconds / 86400);

    const hours =
      Math.floor(
        (totalSeconds % 86400) / 3600
      );

    const minutes =
      Math.floor(
        (totalSeconds % 3600) / 60
      );

    const seconds =
      totalSeconds % 60;

    return {
      expired: false,
      text:
        pad(days) + "日 " +
        pad(hours) + "時 " +
        pad(minutes) + "分 " +
        pad(seconds) + "秒",
    };
  }


  /*
   * ----------------------------------------------------------
   * ORIGINAL CONTROL STATE
   * ----------------------------------------------------------
   *
   * We only change controls for expired Product Card countdowns.
   *
   * This means a genuinely unavailable / sold-out Shopify
   * control remains unavailable for its own reason.
   */

  function rememberControlState(control) {
    if (
      !Object.prototype.hasOwnProperty.call(
        control.dataset,
        "kouritenOriginalDisabled"
      )
    ) {
      control.dataset.kouritenOriginalDisabled =
        control.disabled ? "true" : "false";
    }

    if (
      !Object.prototype.hasOwnProperty.call(
        control.dataset,
        "kouritenOriginalAriaDisabled"
      )
    ) {
      const aria =
        control.getAttribute("aria-disabled");

      control.dataset.kouritenOriginalAriaDisabled =
        aria === null ? "" : aria;
    }
  }


  function lockControl(control) {
    rememberControlState(control);

    control.disabled = true;

    control.setAttribute(
      "aria-disabled",
      "true"
    );

    control.classList.add(
      DISABLED_CLASS
    );
  }


  /*
   * ----------------------------------------------------------
   * PRODUCT CARD
   * ----------------------------------------------------------
   */

  function getCard(element) {
    return element.closest(
      ".card-wrapper"
    );
  }


  function getCardPurchaseControls(element) {
    const card =
      getCard(element);

    if (!card) {
      return [];
    }

    return Array.from(
      card.querySelectorAll(
        [
          'button[name="add"]',
          'button[type="submit"]',
          'input[type="submit"]',
          ".quick-add__submit",
          ".card__quick-add button",
          ".shopify-payment-button button",
          ".shopify-payment-button__button",
          "[data-shopify-payment-button]",
        ].join(",")
      )
    );
  }


  function updateCardCountdowns() {
    const elements =
      document.querySelectorAll(
        CARD_SELECTOR
      );

    elements.forEach((element) => {
      const endAt =
        element.dataset.countdownEndAt;

      const valueElement =
        element.querySelector(
          ".kouriten-product-card-countdown__value"
        );

      if (!endAt || !valueElement) {
        return;
      }

      const result =
        formatRemaining(endAt);

      if (result === null) {
        return;
      }

      valueElement.textContent =
        result.text;

      element.classList.toggle(
        "kouriten-product-card-countdown--expired",
        result.expired
      );

      const controls =
        getCardPurchaseControls(
          element
        );

      if (result.expired) {
        controls.forEach(
          lockControl
        );
      }
    });
  }


  function init() {
    updateCardCountdowns();

    setInterval(
      updateCardCountdowns,
      1000
    );
  }


  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      init,
      { once: true }
    );
  } else {
    init();
  }
})();
